import { render, staticRenderFns } from "./setReadChooseTextFillBlank.vue?vue&type=template&id=07129bf3&scoped=true"
import script from "./setReadChooseTextFillBlank.vue?vue&type=script&lang=js"
export * from "./setReadChooseTextFillBlank.vue?vue&type=script&lang=js"
import style0 from "./setReadChooseTextFillBlank.vue?vue&type=style&index=0&id=07129bf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07129bf3",
  null
  
)

export default component.exports